module.exports = __webpack_public_path__ + "static/img/mlyu+.01af672.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/mlyu+.png
// module id = 0LX+
// module chunks = 0